import React from 'react';

// Import all product images (not the most efficient way if we start to have many products)
import HoodiePhoto from '../Assets/Images/Products_photo/Hoodie_photo.png';
import TumblerStainlessPhoto from '../Assets/Images/Products_photo/Tumblerstainless_photo.png';
import Tshirt1Photo from '../Assets/Images/Products_photo/Tshirt1_photo.png';
import Tshirt2Photo from '../Assets/Images/Products_photo/Tshirt2_photo.png';
import SweatshirtPhoto from '../Assets/Images/Products_photo/sweatshirt_photo.png';
import TowelPhoto from '../Assets/Images/Products_photo/Towel_photo.png';
import UsbKeyPhoto from '../Assets/Images/Products_photo/Usbkey_photo.png';
import CoffeeMugPhoto from '../Assets/Images/Products_photo/Coffeemug_photo.png';
import BucketHatPhoto from '../Assets/Images/Products_photo/Buckethat_photo.png';
import DuffleBagPhoto from '../Assets/Images/Products_photo/Dufflebag_photo.png';
import TuquePhoto from '../Assets/Images/Products_photo/Tuque_photo.png';
import IphoneCasePhoto from '../Assets/Images/Products_photo/Iphonecase_photo.png';
import MousePadPhoto from '../Assets/Images/Products_photo/Mousepad_photo.png';
import PenPhoto from '../Assets/Images/Products_photo/Pen_photo.png';
import WTshirtPhoto from '../Assets/Images/Products_photo/Wtshirt_photo.png';

const products = [
  { id: 1, title: 'Hoodie', imageUrl: HoodiePhoto, description: 'Custom hoodies' },
  { id: 2, title: 'Tumbler Stainless', imageUrl: TumblerStainlessPhoto, description: 'Custom stainless tumblers' },
  { id: 3, title: 'T-Shirt', imageUrl: Tshirt1Photo, description: 'Custom T-shirts' },
  { id: 4, title: 'Backpack', imageUrl: Tshirt2Photo, description: 'Custom Backpacks' },
  { id: 5, title: 'Sweatshirt', imageUrl: SweatshirtPhoto, description: 'Custom sweatshirts' },
  { id: 6, title: 'Towel', imageUrl: TowelPhoto, description: 'Custom towels' },
  { id: 7, title: 'Coffee Mug', imageUrl: CoffeeMugPhoto, description: 'Custom coffee mugs' },
  { id: 8, title: 'Bucket Hat', imageUrl: BucketHatPhoto, description: 'Custom bucket hats' },
  { id: 9, title: 'USB Key', imageUrl: UsbKeyPhoto, description: 'Custom USB keys' },
  { id: 10, title: 'Duffle Bag', imageUrl: DuffleBagPhoto, description: 'Custom duffle bags' },
  { id: 11, title: 'Beanie', imageUrl: TuquePhoto, description: 'Custom Beanies' },
  { id: 12, title: 'iPhone Case', imageUrl: IphoneCasePhoto, description: 'Custom iPhone cases' },
  { id: 13, title: 'Mousepad', imageUrl: MousePadPhoto, description: 'Custom mousepads' },
  { id: 14, title: 'Pen', imageUrl: PenPhoto, description: 'Custom pens' },
  { id: 15, title: 'Women’s T-Shirt', imageUrl: WTshirtPhoto, description: 'Custom women’s T-shirts' },
];

export default function CorporateProducts() {
  return (
    <div className="corporate-products-container">
      <div className="corporate-header">
        <h1 className="title">PROMOTIONAL ITEMS</h1>
        <p className="description">Promotional corporate products such as custom mugs, bottles, t-shirts and more! Shop for customized products with your logo, slogan or design.</p>
      </div>
      <div className="product-grid">
        {products.map((product) => (
          <div key={product.id} className="product-card">
            <img src={product.imageUrl} alt={product.title} />
            <h3>{product.title}</h3>
            <p>{product.description}</p>
            {/* Add more product details here */}
          </div>
        ))}
      </div>
    </div>
  );
}
